import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const WisdomBotSvg = () => (
  <svg
    className='bot'
    width='1em'
    height='0.9em'
    viewBox='0 0 36 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.3874 22.3401C11.5719 22.3407 10.79 22.6528 10.2134 23.208C9.63672 23.7632 9.31253 24.516 9.31199 25.3012H11.3433C11.3439 25.0347 11.454 24.7793 11.6497 24.5909C11.8454 24.4025 12.1107 24.2964 12.3874 24.2959C12.6645 24.2959 12.9303 24.4018 13.1264 24.5902C13.3226 24.7787 13.433 25.0344 13.4336 25.3012H15.4649C15.4638 24.5159 15.1392 23.763 14.5622 23.2079C13.9852 22.6527 13.2031 22.3407 12.3874 22.3401Z'
      fill='url(#paint0_linear_705_5594)'
    />
    <path
      d='M23.4419 24.4778C23.719 24.4783 23.9846 24.5847 24.1803 24.7735C24.3761 24.9623 24.486 25.2182 24.486 25.485H26.5174C26.5168 24.6997 26.1927 23.9466 25.6161 23.3911C25.0395 22.8356 24.2576 22.5231 23.4419 22.522C22.6257 22.5231 21.8433 22.8358 21.2663 23.3917C20.6893 23.9476 20.365 24.7011 20.3645 25.487H22.3958C22.3958 25.2197 22.5059 24.9633 22.7021 24.7741C22.8982 24.5849 23.1643 24.4783 23.4419 24.4778Z'
      fill='url(#paint1_linear_705_5594)'
    />
    <path
      d='M18.3413 33.3512H18.5667C20.0354 33.2749 21.3253 32.4848 22.4019 31.0042C22.4795 30.8988 22.5347 30.7796 22.5641 30.6534C22.5936 30.5273 22.5968 30.3969 22.5736 30.2695C22.5504 30.1422 22.5011 30.0206 22.4288 29.9117C22.3564 29.8028 22.2624 29.7089 22.152 29.6352C22.0424 29.5605 21.9184 29.5076 21.7874 29.4794C21.6563 29.4511 21.5207 29.4482 21.3885 29.4708C21.2563 29.4933 21.13 29.5409 21.017 29.6107C20.9039 29.6806 20.8064 29.7713 20.7301 29.8777C20.0334 30.836 19.2696 31.3445 18.457 31.3895C17.1468 31.4619 15.8041 30.3315 15.3979 29.8895C15.2208 29.6975 14.9725 29.5803 14.7064 29.5631C14.4404 29.5459 14.178 29.6301 13.9759 29.7975C13.8753 29.882 13.7929 29.9847 13.7335 30.0998C13.6741 30.2149 13.6389 30.3402 13.6298 30.4685C13.6208 30.5967 13.6381 30.7254 13.6807 30.8472C13.7234 30.969 13.7906 31.0815 13.8784 31.1783C13.9576 31.2722 15.8752 33.3512 18.3413 33.3512Z'
      fill='url(#paint2_linear_705_5594)'
    />
    <path
      d='M33.3061 22.7606L31.6383 21.7397C31.6038 21.7202 31.5693 21.7065 31.5327 21.6889C31.5226 21.5793 31.5144 21.4659 31.5022 21.3564C31.4472 20.8731 31.3306 20.3982 31.1549 19.9424C31.0251 19.6029 30.8633 19.2755 30.6714 18.9645C30.2784 18.3324 29.7834 17.7646 29.2048 17.2825C28.704 16.8637 28.1594 16.496 27.5797 16.1853C27.403 16.0895 27.2222 15.9897 27.0353 15.9095C26.4258 15.6209 25.7951 15.3757 25.1482 15.1761C24.6465 15.0197 24.1326 14.8808 23.5861 14.7635C23.0627 15.3721 22.4775 15.929 21.8392 16.4259C22.2455 16.4865 22.6517 16.5589 23.0357 16.643C23.9816 16.8362 24.9045 17.1219 25.7901 17.4957C26.0664 17.615 26.3325 17.7441 26.5844 17.8868C26.9988 18.1086 27.3911 18.3665 27.7565 18.6574C28.7721 19.4749 29.3511 20.4528 29.4831 21.5754C29.6486 22.9942 29.6268 24.4275 29.4181 25.841C28.9631 28.9546 27.6183 31.8804 25.5464 34.1139C23.4744 36.3474 20.9149 37.5815 18.3494 37.5815C15.7838 37.5815 13.0842 36.5645 10.9736 34.7926C9.88163 33.8731 8.96222 32.7795 8.25569 31.5597C6.66719 28.8412 6.02123 25.4674 6.30561 21.5344C6.43156 19.8504 8.00178 18.7004 9.29573 18.0316C9.58418 17.8829 9.88685 17.7421 10.1997 17.6111C11.1178 17.2326 12.0697 16.9347 13.0435 16.7212H13.0821C12.8737 16.067 12.8808 15.3667 13.1025 14.7165C12.2701 14.8801 11.4492 15.0937 10.6445 15.3561C10.0063 15.5634 9.38278 15.8104 8.77775 16.0953C8.62337 16.1657 8.47508 16.2401 8.32679 16.3163C5.82622 17.6091 4.42461 19.3674 4.26413 21.4014C4.25194 21.5657 4.24382 21.728 4.23366 21.8903L2.79954 22.7724C1.87485 23.3457 1.16665 24.1907 0.779903 25.182C0.393159 26.1733 0.348458 27.2582 0.652425 28.2759C0.960088 29.2915 1.60158 30.1837 2.48062 30.8184C3.35966 31.4532 4.42882 31.7963 5.52762 31.7963C5.69995 31.7966 5.87217 31.7881 6.04358 31.7709H6.05779C6.1878 32.0232 6.32187 32.2755 6.46406 32.52C7.29078 33.9344 8.36488 35.2007 9.63903 36.2633C12.1132 38.3404 15.2882 39.5334 18.3494 39.5334C21.5 39.5334 24.5937 38.0685 27.0618 35.4106C28.0883 34.299 28.9541 33.0589 29.6354 31.724L30.0559 31.765C30.2273 31.7822 30.3996 31.7907 30.5719 31.7905C31.6707 31.7905 32.7398 31.4473 33.6189 30.8126C34.4979 30.1778 35.1394 29.2857 35.4471 28.2701C35.7537 27.2522 35.711 26.1662 35.3253 25.1736C34.9395 24.181 34.2314 23.3347 33.3061 22.7606ZM2.61875 27.7166C2.43615 27.1051 2.463 26.4532 2.69533 25.8575C2.92766 25.2618 3.35311 24.754 3.90865 24.4094L4.22553 24.2138C4.28024 26.1191 4.62237 28.0066 5.2412 29.8171C4.63632 29.7588 4.06338 29.5276 3.59606 29.1533C3.12873 28.779 2.78837 28.2786 2.61875 27.7166ZM33.5051 27.7166C33.3146 28.3413 32.9144 28.8876 32.3672 29.2701C31.8199 29.6527 31.1564 29.8498 30.4805 29.8308C31.1723 27.9689 31.5568 26.0142 31.6201 24.0378L32.2295 24.4094C32.7827 24.7557 33.2054 25.2643 33.4352 25.8599C33.6649 26.4555 33.6894 27.1065 33.5051 27.7166Z'
      fill='url(#paint3_linear_705_5594)'
    />
    <path
      d='M14.9489 16.8835L16.6938 17.9533C16.9969 18.1405 17.3495 18.2397 17.7095 18.2389C17.8461 18.2377 17.9822 18.2233 18.1158 18.1958C18.3573 18.1447 18.5859 18.048 18.7885 17.9114C18.991 17.7748 19.1635 17.6009 19.296 17.3998L20.1207 16.1579L20.1451 16.1169C20.4904 15.5301 21.1607 15.2133 21.6625 15.0451C22.3773 14.8074 23.0474 14.46 23.6471 14.0163C24.2467 13.6335 24.7555 13.1329 25.1401 12.5476C25.8754 11.4343 26.1219 10.0856 25.8256 8.79758C25.5293 7.50951 24.7144 6.3872 23.5597 5.6769C23.2773 5.50442 22.9779 5.359 22.666 5.24272L22.5644 5.20556C22.1345 5.05188 21.6848 4.9558 21.2278 4.92002L20.7423 4.90242C19.8811 4.91193 19.0358 5.12726 18.2823 5.52905C17.5289 5.93084 16.8909 6.50651 16.4257 7.20437C15.9109 7.97619 15.6295 8.87082 15.6132 9.78795C15.5485 10.3002 15.5437 10.8178 15.599 11.3311C15.6518 11.8376 15.6315 12.5573 15.2293 13.1069L14.3781 14.3899C14.113 14.7941 14.0242 15.2828 14.131 15.7497C14.2379 16.2166 14.5318 16.6241 14.9489 16.8835ZM17.6608 16.2283L16.1758 15.3169L16.9092 14.2119L16.9457 14.1552L17.5186 14.5072C17.8801 14.7302 18.1909 14.9356 18.4103 15.094L18.39 15.1214L17.6608 16.2283ZM17.6404 9.97962V9.85249C17.6435 9.28158 17.817 8.72354 18.1401 8.24484C18.4334 7.80697 18.8388 7.44919 19.3173 7.20598C19.7958 6.96277 20.3314 6.84232 20.8723 6.85624H20.9109C21.1991 6.86672 21.4844 6.91677 21.7579 7.00488L21.8676 7.04204C22.0776 7.11515 22.2785 7.21025 22.4669 7.32563C23.1676 7.7572 23.6621 8.43868 23.8418 9.22067C24.0215 10.0027 23.8719 10.8214 23.4257 11.4973C23.1885 11.859 22.8724 12.1666 22.4994 12.3989L22.4242 12.4517C21.9914 12.775 21.5062 13.0275 20.9881 13.1988C20.5853 13.3315 20.1991 13.5066 19.8363 13.721C19.7808 13.6611 19.7211 13.6049 19.6576 13.5528C19.6783 13.5642 19.6981 13.5773 19.7165 13.5919L19.6169 13.5176C19.5722 13.4805 19.5235 13.4453 19.4707 13.4081C19.235 13.2419 18.9486 13.0541 18.6175 12.8487L18.1361 12.5476L17.6303 12.2366C17.6691 11.8653 17.6691 11.4911 17.6303 11.1198C17.5875 10.7407 17.5909 10.358 17.6404 9.97962Z'
      fill='url(#paint4_linear_705_5594)'
    />
    <path
      d='M29.2617 10.6876L27.594 10.1263C27.4681 10.0836 27.3346 10.0652 27.2013 10.0721C27.068 10.0791 26.9375 10.1113 26.8171 10.1669C26.6967 10.2224 26.5889 10.3003 26.4999 10.3961C26.4108 10.4918 26.3422 10.6035 26.298 10.7248C26.254 10.846 26.2352 10.9744 26.2427 11.1026C26.2502 11.2308 26.2839 11.3564 26.3418 11.472C26.3997 11.5877 26.4807 11.6913 26.5802 11.7768C26.6797 11.8624 26.7957 11.9282 26.9216 11.9706L28.5914 12.5339C28.6991 12.5701 28.8124 12.5886 28.9265 12.5886C29.1347 12.5858 29.337 12.5215 29.506 12.4043C29.6749 12.2871 29.8024 12.1227 29.8711 11.9334C29.9607 11.6904 29.9469 11.4231 29.8328 11.1897C29.7186 10.9564 29.5134 10.7759 29.2617 10.6876Z'
      fill='url(#paint5_linear_705_5594)'
    />
    <path
      d='M25.9201 7.52512C25.9739 7.73818 26.1004 7.92767 26.2795 8.06316C26.4585 8.19865 26.6796 8.27228 26.9074 8.27222C26.9881 8.27267 27.0687 8.26347 27.1471 8.24484L29.0586 7.79892C29.319 7.73812 29.544 7.58066 29.6844 7.36085C29.8248 7.14104 29.8693 6.8767 29.8081 6.62546C29.7445 6.37503 29.5808 6.15892 29.3525 6.02413C29.1243 5.88935 28.85 5.84679 28.5893 5.90573L26.6758 6.35165C26.4142 6.41116 26.1878 6.56809 26.0461 6.78805C25.9045 7.008 25.8592 7.27305 25.9201 7.52512Z'
      fill='url(#paint6_linear_705_5594)'
    />
    <path
      d='M23.9904 5.44221C24.1529 5.54247 24.3418 5.59607 24.5348 5.59672C24.7075 5.59834 24.8778 5.55752 25.0296 5.47813C25.1813 5.39873 25.3096 5.28338 25.4022 5.14298L26.3975 3.64094C26.542 3.42227 26.5905 3.1573 26.5322 2.90426C26.4739 2.65122 26.3137 2.43081 26.0867 2.29145C25.9742 2.22225 25.8486 2.17509 25.7171 2.15267C25.5856 2.13026 25.4508 2.13303 25.3204 2.16082C25.1901 2.18862 25.0667 2.24089 24.9573 2.31465C24.8479 2.38841 24.7547 2.48221 24.6831 2.59068L23.6897 4.09272C23.5443 4.31021 23.4943 4.57432 23.5506 4.82725C23.6069 5.08017 23.7651 5.30129 23.9904 5.44221Z'
      fill='url(#paint7_linear_705_5594)'
    />
    <path
      d='M16.1494 5.35224C16.2446 5.45379 16.3609 5.53498 16.4907 5.59057C16.6205 5.64615 16.761 5.6749 16.9031 5.67495C17.1545 5.67485 17.397 5.58495 17.5836 5.42265C17.7831 5.24858 17.9027 5.00535 17.916 4.74643C17.9293 4.48751 17.8353 4.23409 17.6547 4.04187L16.3932 2.6963C16.2124 2.50419 15.9598 2.38907 15.6909 2.37624C15.4219 2.3634 15.1587 2.4539 14.9591 2.62784C14.7593 2.80165 14.6393 3.04473 14.6256 3.30366C14.6119 3.56258 14.7055 3.81615 14.886 4.00862L16.1494 5.35224Z'
      fill='url(#paint8_linear_705_5594)'
    />
    <path
      d='M19.4219 3.46492C19.4587 3.6954 19.5799 3.90563 19.7635 4.05769C19.9471 4.20974 20.1812 4.29361 20.4234 4.29417C20.4757 4.29415 20.528 4.29022 20.5798 4.28243C20.7123 4.26291 20.8396 4.21831 20.9541 4.1512C21.0687 4.0841 21.1683 3.99581 21.2472 3.89144C21.3262 3.78708 21.3829 3.66869 21.4141 3.54312C21.4452 3.41755 21.4503 3.28727 21.4289 3.15982L21.177 1.59519C21.136 1.339 20.9909 1.10897 20.7738 0.955676C20.5567 0.80238 20.2853 0.738356 20.0191 0.777677C19.8872 0.797232 19.7605 0.841644 19.6464 0.908372C19.5323 0.9751 19.433 1.06283 19.3541 1.16656C19.2752 1.27028 19.2184 1.38795 19.1868 1.51285C19.1552 1.63774 19.1495 1.76741 19.17 1.89443L19.4219 3.46492Z'
      fill='url(#paint9_linear_705_5594)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_705_5594'
        x1='0.453125'
        y1='0.766357'
        x2='36.9484'
        y2='2.03031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const WisdomBotColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WisdomBotSvg} {...props} />
);
